var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlickr = function SvgFlickr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 457.1 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M357.1 42.9c-31.5 0-57.1 25.6-57.1 57.1s25.6 57.1 57.1 57.1 57.1-25.6 57.1-57.1-25.5-57.1-57.1-57.1m0-42.9c55.2 0 100 44.8 100 100s-44.8 100-100 100-100-44.8-100-100S301.9 0 357.1 0M0 100c0 55.2 44.8 100 100 100s100-44.8 100-100S155.2 0 100 0 0 44.8 0 100"
  })));
};
export default SvgFlickr;